import { render, staticRenderFns } from "./AboutDesktop.vue?vue&type=template&id=21d14336&"
import script from "./AboutDesktop.vue?vue&type=script&lang=ts&"
export * from "./AboutDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports